import React from 'react'
import Header from './Header'
import Group from './Group'
import Team from './Team'
import WhyChooseSection from './WhyChooseSection'
import Footer from './Footer'

function Teampage() {
  return (
    <div>
      {/* <Header/> */}
      {/* <Group/> */}
      <Team/>
      {/* <WhyChooseSection/> */}
      {/* <Footer/> */}


    </div>
  )
}

export default Teampage
